import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import logoImg from '../assets/LOGO.png';

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer" data-testid="footer">
      <div className="container">
        <div className="footer-top">
          <div>
            <div className="footer-brand">
              <img src={logoImg} alt="Legend Spa Hotel Logo" />
              <div className="footer-brand-text">
                <h3>Legend Spa Hotel</h3>
                <p>Legends Never Die</p>
              </div>
            </div>
            <p className="footer-tagline">
              {t('footer.tagline')}
            </p>
          </div>

          <div className="footer-links">
            <Link to="/imprint" className="footer-link" data-testid="footer-imprint-link">
              {t('footer.imprint')}
            </Link>
            <Link to="/privacy" className="footer-link" data-testid="footer-privacy-link">
              {t('footer.privacy')}
            </Link>
            <a
              href="https://lspa-token.info"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link-token"
              data-testid="footer-token-link"
            >
              <ExternalLink size={12} />
              {t('footer.token')}
            </a>
          </div>
        </div>

        <hr className="gold-divider" />

        <div className="footer-bottom">
          <p className="footer-rights">{t('footer.rights')}</p>
          <p className="footer-location">{t('footer.location')}</p>
        </div>
      </div>
    </footer>
  );
};
